import * as React from "react"
import type { SVGProps } from "react"
const SvgCalendarEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.29q-.82 0-1.41-.6A2 2 0 0 1 3 20.3v-14q0-.82.59-1.42A2 2 0 0 1 5 4.3h1v-1q0-.44.29-.72A1 1 0 0 1 7 2.3q.42 0 .71.28.3.3.29.72v1h8v-1q0-.44.29-.72A1 1 0 0 1 17 2.3q.42 0 .71.28.3.3.29.72v1h1q.83 0 1.41.58.6.6.59 1.42v14q0 .83-.59 1.4a2 2 0 0 1-1.41.6zm0-2h14v-10H5zm0-12h14v-2H5z" />
  </svg>
)
export default SvgCalendarEmpty
